import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './SplashScreen.css';

const SplashScreen = ({ onComplete }) => {
  const { t } = useTranslation('splash');
  const [isVisible, setIsVisible] = useState(true);
  const [logoScale, setLogoScale] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Check if splash has been shown before
    const hasSeenSplash = localStorage.getItem('st_cael_splash_shown');
    
    if (hasSeenSplash) {
      // If already shown, skip splash
      onComplete();
      return;
    }

    // Logo scale animation
    const logoTimer = setTimeout(() => {
      setLogoScale(1);
    }, 100);

    // Progress bar animation
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return prev + 2;
      });
    }, 30);

    // Complete splash after 2.5 seconds
    const completeTimer = setTimeout(() => {
      setIsVisible(false);
      localStorage.setItem('st_cael_splash_shown', 'true');
      
      // Wait for fade out animation before calling onComplete
      setTimeout(() => {
        onComplete();
      }, 500);
    }, 2500);

    return () => {
      clearTimeout(logoTimer);
      clearInterval(progressInterval);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  if (!isVisible && progress >= 100) {
    return null;
  }

  return (
    <div className={`splash-screen ${!isVisible ? 'fade-out' : ''}`}>
      <div className="splash-background">
        <div className="splash-gradient"></div>
        <div className="splash-particles">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="particle" style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}></div>
          ))}
        </div>
      </div>
      
      <div className="splash-content">
        <div 
          className="splash-logo-container"
          style={{ transform: `scale(${logoScale})` }}
        >
          <img 
            src="/logo192.png" 
            alt={t('title')} 
            className="splash-logo"
          />
          <div className="logo-glow"></div>
        </div>
        
        <h1 className="splash-title">{t('title')}</h1>
        <p className="splash-subtitle">{t('subtitle')}</p>
        
        <div className="splash-progress-container">
          <div 
            className="splash-progress-bar"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;

